import { Redirect, Route, Router, Switch } from "react-router";
import Accounts from "../pages/Accounts";
import LandbotChannels from "../pages/LandbotChannel";
import Login from "../pages/Login";
import NotFound from "../pages/NotFound";
import NumberOfficial from "../pages/NumberOfficial";
import Sector from "../pages/Sectors";
import { Auth } from "../services/Auth";
import history from "./history";
import CheckTemplates from "../pages/CheckTemplates";
import { WhatsappUsage } from "../pages/WhatsappUsage";
import { Updates } from "../pages/Updates";
import { BotBuilder } from "../pages/BotBuilder";
import Operators from "../pages/Operators";
import Managers from "../pages/Managers";
import { UpdatesExtension } from "../pages/UpdatesExtension";
const PrivateRoutes = ({ component: Component, ...rest }) => {
	return (
		<Route
			{...rest}
			render={(props) =>
				localStorage.getItem("token") ? (
					<Component {...props} />
				) : (
					<Redirect to="/" />
				)
			}
		/>
	);
};

const NotAllowedLoggedRoute = ({ component: Component, ...rest }) => {
	let activeTab = localStorage.getItem("active-page");

	return (
		<Route
			{...rest}
			render={(props) =>
				!new Auth().getToken() ? (
					<Component {...props} />
				) : (
					<Redirect to={activeTab?.length ? `/${activeTab}` : "/accounts"} />
				)
			}
		/>
	);
};

function Routes() {
	return (
		<Router history={history}>
			<Switch>
				<NotAllowedLoggedRoute exact path="/" component={Login} />
				<PrivateRoutes exact path="/accounts" component={Accounts} />
				<PrivateRoutes exact path="/sectors" component={Sector} />
				<PrivateRoutes exact path="/operators" component={Operators} />
				<PrivateRoutes exact path="/managers" component={Managers} />
				<PrivateRoutes
					exact
					path="/landbotchannel"
					component={LandbotChannels}
				/>
				<PrivateRoutes exact path="/bot-builder" component={BotBuilder} />
				{/* <PrivateRoutes exact path="/numberMonitor" component={NumberMonitor} /> */}
				<PrivateRoutes
					exact
					path="/numberOfficial"
					component={NumberOfficial}
				/>
				<PrivateRoutes exact path="/checkTemplate" component={CheckTemplates} />
				<PrivateRoutes exact path="/whatsapp-usage" component={WhatsappUsage} />
				<PrivateRoutes exact path="/updates" component={Updates} />
				<PrivateRoutes
					exact
					path="/updates-extension"
					component={UpdatesExtension}
				/>

				<Route path="*" exact component={NotFound} />
			</Switch>
		</Router>
	);
}

export default Routes;
